"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
// eslint-disable-next-line
exports.ja = {
    locale: 'ja',
    // 操作：确定按钮
    resetText: ('Reset'),
    // 暂无数据
    noData: ('No Data Found'),
};
//# sourceMappingURL=ja.js.map